import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { SharedModule } from '@tv3/shared/shared.module'

import { DateRangeSelectComponent } from './date-range-select/date-range-select.component'
import { ShareCalendarDialogComponent } from './dialogs/share-calendar-dialog/share-calendar-dialog.component'
import { EditHoldDialogComponent } from '../hold/edit-hold-dialog/edit-hold-dialog.component'
import { AddHoldDialogComponent } from '@tv3/containers/calendar/hold/add-hold-dialog/add-hold-dialog.component'
import { DefaultCalendarIndicatorComponent } from './default-calendar-indicator/default-calendar-indicator.component'
import { ImportHoldsDialogComponent } from '@tv3/containers/calendar/hold/import-holds-dialog/import-holds-dialog.component'
import { BookingDetailsPopupComponent } from './booking-details-popup/booking-details-popup.component'
import { BookingDetailsDirective } from './booking-details-popup/booking-details.directive'
import { EditHoldDialogService } from '@tv3/containers/calendar/hold/edit-hold-dialog/edit-hold-dialog.service'
import { BookingDetailsPopupService } from '@tv3/containers/calendar/shared/booking-details-popup/booking-details-popup.service'
import { AddHoldDialogService } from '../hold/add-hold-dialog/add-hold-dialog.service'
import { BookingFeesModule } from '@tokeet-frontend/booking-fees'
import { UsersLibModule } from '@tokeet-frontend/users'

const components = [DateRangeSelectComponent, DefaultCalendarIndicatorComponent, BookingDetailsDirective]

const dialogs = [
  ShareCalendarDialogComponent,
  AddHoldDialogComponent,
  EditHoldDialogComponent,
  ImportHoldsDialogComponent,
  BookingDetailsPopupComponent,
]

const providers = [AddHoldDialogService, EditHoldDialogService, BookingDetailsPopupService]

@NgModule({
  imports: [SharedModule, CommonModule, BookingFeesModule, UsersLibModule],
  declarations: [...components, ...dialogs],
  exports: [...components, ...dialogs],
  providers: [...providers],
  entryComponents: [...dialogs],
})
export class CalendarSharedModule {}
